// extracted by mini-css-extract-plugin
export default {"list":"y23ossihTB","item":"sKSCngVD2b"};